<div class="contacts-wrapper" data-testid="bcr-172-contacts-wrapper">
  <app-toolbar
    [pageTitle]="documentTitle() + ' Contacts'"
    backLink="/document-repository"
    backLinkLabel="Back to Document Repository"
    backLinkTestId="bcr-172-back-link"
  />

  <section class="feature-shell">
    <!-- Loading overlay -->
    <div
      *ngIf="loading()"
      class="loading-overlay"
      data-testid="bcr-172-loading-overlay"
      aria-live="polite"
      aria-label="Loading contacts"
    >
      <app-spinner [display]="true" [diameter]="48" aria-label="Loading" />
    </div>

    <!-- Contact tables (hidden while loading) -->
    <ng-container *ngIf="!loading()">
      <!-- IGA Coordinators section -->
      <div class="contacts-section" data-testid="bcr-172-iga-coordinators-section">
        <h2 class="section-title">IGA Coordinators</h2>
        <app-az-table
          data-testid="bcr-172-iga-coordinators-table"
          [data]="igaRows()"
          [columns]="igaColumns"
          [emptyMessage]="'No IGA Coordinators found'"
        />
      </div>

      <!-- Legal Entity Contacts section -->
      <div class="contacts-section" data-testid="bcr-172-legal-entity-contacts-section">
        <div class="section-header">
          <h2 class="section-title">Legal Entity Contacts</h2>
          <app-az-button
            data-testid="bcr-172-notify-all-btn"
            label="Notify All"
            icon="notifications"
            variant="primary"
            (click)="onNotifyAll()"
          />
        </div>
        <app-az-table
          data-testid="bcr-172-legal-entity-contacts-table"
          [data]="legalEntityRows()"
          [columns]="legalEntityColumns"
          [emptyMessage]="'No Legal Entity Contacts found'"
        />
      </div>
    </ng-container>
  </section>

  <app-footer />

  <!-- Error modal -->
  <app-status-change-modal
    data-testid="bcr-172-error-modal"
    [isOpen]="isErrorModalOpen()"
    [initialState]="'error'"
    [title]="'Error'"
    [errorMessage]="errorMessage()"
    (close)="onErrorModalClose()"
  />
</div>
